// src/MaintenanceIcon.tsx
import { jsx } from "react/jsx-runtime";
var MaintenanceIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "m10.901 1.144 1.063 2.127c0.143 0.294 0.528 0.573 0.851 0.633l1.922 0.316c1.228 0.203 1.514 1.093 0.633 1.983L13.872 7.701c-0.248 0.248 -0.392 0.739 -0.309 1.093l0.429 1.854c0.34 1.462 -0.446 2.035 -1.733 1.267l-1.801 -1.07c-0.323 -0.196 -0.867 -0.196 -1.191 0l-1.801 1.069c-1.288 0.761 -2.072 0.196 -1.732 -1.267l0.429 -1.854c0.068 -0.362 -0.075 -0.851 -0.323 -1.1L4.339 6.193c-0.882 -0.881 -0.596 -1.77 0.633 -1.982l1.921 -0.316c0.323 -0.053 0.709 -0.339 0.851 -0.633L8.807 1.137c0.58 -1.145 1.514 -1.145 2.094 0.007m-5.568 0.408H0.812A0.571 0.571 0 0 1 0.246 0.987 0.571 0.571 0 0 1 0.812 0.422h4.521c0.309 0 0.565 0.257 0.565 0.566a0.571 0.571 0 0 1 -0.565 0.565M3.073 12.103H0.812a0.571 0.571 0 0 1 -0.566 -0.566c0 -0.309 0.257 -0.565 0.566 -0.565h2.261c0.309 0 0.565 0.256 0.565 0.565a0.571 0.571 0 0 1 -0.565 0.566M1.565 6.826H0.812A0.571 0.571 0 0 1 0.246 6.261c0 -0.309 0.257 -0.565 0.566 -0.565H1.565c0.309 0 0.566 0.256 0.566 0.565a0.571 0.571 0 0 1 -0.566 0.566",
        fill: "#fff"
      }
    )
  }
);
var MaintenanceIcon_default = MaintenanceIcon;

export {
  MaintenanceIcon_default
};
